import { render, staticRenderFns } from "./WFCaseQueryConfigIndex.vue?vue&type=template&id=66a890ae&scoped=true"
import script from "./WFCaseQueryConfigIndex.vue?vue&type=script&lang=js"
export * from "./WFCaseQueryConfigIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a890ae",
  null
  
)

export default component.exports